@if ((spinner$ | async)?.show) {
  <div class="spinner">
    <ngx-spinner bdColor="rgba(255, 255, 255, 0)" size="medium" color="#000" type="ball-scale-ripple-multiple" [fullScreen]="false"><p style="color: black" > Loading... </p></ngx-spinner>
  </div>
}
@if (blogPost) {
  <div class="toolbar-break">
  </div>
  <div class="container mt-5">
    <div class="row">
      <div class="col-12 col-lg-5">
        @if (blogPost.read_time) {
          <div class="d-flex justify-content-center align-items-center badge">
            <p class="mb-0 pb-0">{{blogPost.read_time}} minute read</p>
          </div>
        }
        <app-image class="blog-image" [prismicImage]="blogPost.blog_hero_image" [bcimage]="true"></app-image>
      </div>
      <div class="col-12 col-lg-7 ps-lg-5">
        <div class="break d-flex justify-content-between align-items-center">
          <div class="">
            <p class="title-secondary">{{blogPost.category | uppercase}}</p>
          </div>
          <div>
            <p class="">{{blogPost.last_modified_date | date:'M/d/yyyy' }}</p>
          </div>
        </div>
        <h1>{{blogPost.blog_title}}</h1>
        <div class="d-flex justify-content-start align-items-center">
          <img class="headshot" [src]="blogPost.blog_author_image.url" [alt]="blogPost.blog_author" />
          <div class="ms-3 mt-3" [innerHTML]="blogPost.blog_author"></div>
        </div>
        <div class="mt-4 mb-2" style="width: 20%;">
          <div class="line-break"></div>
          <br />
        </div>
        <div [innerHTML]="blogPost.introduction"></div>
      </div>
      <div>
        <img class="wave-right" src="assets/images/pink-curve-right.png" alt="Pink Wave Decoration">
      </div>
    </div>
    <div class="my-5 py-5 mx-0 mx-lg-5 px-3 px-lg-5">
      <h2>{{blogPost.blogParagraph.subsections[0].subtitle}}</h2>
      <div [innerHtml]="blogPost.blogParagraph.subsections[0].paragraph"></div>
    </div>
    @if (blogPost.blogParagraph.subsections[0].image?.url) {
      <div class="d-flex justify-content-center my-3">
        <app-image class="paragraph-image" [prismicImage]="blogPost.blogParagraph.subsections[0].image"></app-image>
      </div>
    }
    <div class="my-5 py-5 mx-0 mx-lg-5 px-3 px-lg-5">
      <h2>{{blogPost.blogParagraph.subsections[1].subtitle}}</h2>
      <div [innerHtml]="blogPost.blogParagraph.subsections[1].paragraph"></div>
      <div class="d-flex justify-content-center my-3">
      </div>
    </div>
    @if (blogPost.blogParagraph.subsections[1].image?.url) {
      <div class="d-flex justify-content-center my-3">
        <app-image class="paragraph-image" [prismicImage]="blogPost.blogParagraph.subsections[1].image"></app-image>
      </div>
    }
    <div class="my-5 py-5 mx-0 mx-lg-5 px-3 px-lg-5">
      <h2>{{blogPost.blogParagraph.subsections[2].subtitle}}</h2>
      <div [innerHtml]="blogPost.blogParagraph.subsections[2].paragraph"></div>
    </div>
    <div class="d-flex justify-content-center my-3">
      @if (phosphateRemover) {
        <app-product-card [product]="phosphateRemover"></app-product-card>
      }
    </div>
    <div class="my-5 py-5 mx-0 mx-lg-5 px-3 px-lg-5">
      <h2>{{blogPost.blogParagraph.subsections[3].subtitle}}</h2>
      <div [innerHtml]="blogPost.blogParagraph.subsections[3].paragraph"></div>
    </div>
    <div class="my-5 py-5 mx-0 mx-lg-5 px-3 px-lg-5">
      <h2>{{blogPost.blogParagraph.subsections[4].subtitle}}</h2>
      <div [innerHtml]="blogPost.blogParagraph.subsections[4].paragraph"></div>
    </div>
    @if (blogPost.blogParagraph.subsections[4].image?.url) {
      <div class="d-flex justify-content-center my-3">
        <app-image class="paragraph-image" [prismicImage]="blogPost.blogParagraph.subsections[4].image"></app-image>
      </div>
    }
    <p class="text-center mb-4">
      Explore our full selection of <a class="link important" routerLink="/brands/poolife">Poolife pool care products</a>
      for simple, consistent water maintenance.
    </p>
    <div class="d-flex justify-content-center w-100 mb-5">
      <a class="link important" routerLink="/clear-water-essentials">Shop our best selling pool &amp; spa water clarity essentials.</a>
    </div>
  </div>
}
